

export default class jsonElementExportModel {

    id=''
    type=''
    nom=''
    slug=''
    icone=''
    color='#FF0000'
    appartientA=''
    carac=[]
    lieuModif=[]
    dialogue=[]


    constructor(ELE) {
        this.id=ELE.id
        this.type=ELE.type
        this.nom=ELE.nom
        this.slug=ELE.slug
        this.icone=ELE.icone
        this.color=ELE.color
    }


    addCarac(CARAC) {

        const tmp = {
            clef: CARAC.clef,
            valeur: CARAC.valeur
        }

        this.carac.push(tmp)
    }

    addLieu(LIEU){
        const tmp = {
            id: LIEU.lieu,
            type:LIEU.type
        }

        this.lieuModif.push(tmp)
    }

    addDialogue(REF){
        this.dialogue.push(REF)
    }
}